module.exports = __webpack_public_path__ + "static/media/assembly8.9e36a423.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/assembly8.png
// module id = 2426
// module chunks = 0